// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"LS-z","inlineTitle":"MS-z","sponsoredAdsWrapper":"NS-z","marketplaceRecosWrapper":"OS-z"};